<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import { Table } from "../../components/Table";
  import { initList, loading, records, record, onPrintLabel, labelPrintData, onLabelTypeSelected } from "./transport-document-section-items.store";
  import { record as ddtRecord } from "./transport-document.store";
  import { transportDocumentSectionItemDtoFieldsWithoutWeight } from "../../utils/TableFields/transport-document-item-dto.fields";
  import CustomerLogotypeDropdown from "../../components/Business/CustomerLogotypeDropdown.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import Label from "../../components/Form/Label.svelte";

  export let transportDocumentId: number;

  onMount(() => initList(transportDocumentId));
</script>

{#if !!transportDocumentId && !!$record && !!$ddtRecord && !!$labelPrintData}
  <div class="columns" style="height: unset;">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-4">
          <FormField>
            <Label>
              <span>Tipologia etichetta</span>
            </Label>
            <select class="label-type-selector" bind:value={$labelPrintData.labelType} on:change={onLabelTypeSelected}>
              <option value="INT" selected>Interne per carrelli</option>
              <option value="CUS" selected>Prodotto per vendita</option>
            </select>
          </FormField>
        </div>
        {#if $labelPrintData.labelType == "CUS"}
          <div class="column is-2 has-text-centered">
            <FormField>
              <Switch name="Con logo" bind:value={$labelPrintData.withLogo} on:toggle={(_) => ($labelPrintData.logoId = null)} />
            </FormField>
          </div>
          <div class="column is-4">
            <FormField>
              <CustomerLogotypeDropdown
                name="Logo"
                required={false}
                disabled={$labelPrintData.withLogo == 0}
                clearVisible={true}
                customerId={$ddtRecord.destinationId}
                bind:value={$labelPrintData.logoId}
              />
            </FormField>
          </div>
        {/if}
      </div>
    </div>
  </div>

  <Table
    loading={$loading}
    fields={transportDocumentSectionItemDtoFieldsWithoutWeight}
    records={$records}
    createEnabled={false}
    editEnabled={false}
    deleteEnabled={false}
    exportRecordEnabled={true}
    on:exportRecord={(e) => onPrintLabel(e.detail)}
  />
{/if}

<style>
  .label-type-selector {
    height: 32px;
    width: 100%;
    display: inline-flex;
  }
</style>
